export default __webpack_public_path__ + "static/media/ward_v2_q1_10.ce0e0441.png";